import * as auth from './Auth'

const APIService = {
  ...auth
}

export default APIService